import { FC, useEffect, useState } from "react";
import "../CSS/CalendarDetailScreen.css";
import backIcon from "../../../assets/images/back-icon.svg";
import locationIcon from "../../../assets/images/location-icon.svg";
import { useNavigate } from "react-router-dom";
import ImageCarousel from "components/elements/ImageCarousel";
import {
  MEMBERSHIP_FOUNDER_TYPE,
  MENU_ITEM,
} from "utils/constants";
import { useTabBar } from "services/TabBarProvider";
import { useLogout } from "services/LogoutProvider";
import ROUTE_PATHS from "utils/routePaths";
import { trackDetailView } from "utils/analytics";
import { highlightLastWord } from "utils/utils";

const PassDetailScreen: FC = () => {
  const navigate = useNavigate();
  const { setSelectedTabBar } = useTabBar();
  const { handleAppExit } = useLogout();
  const [selectedPassData, setSelectedPassData] = useState<any>(null);

  useEffect(() => {
    const storedPassData = localStorage.getItem("selectedPassData");
    if (storedPassData) {
      const passData = JSON.parse(storedPassData);
      setSelectedPassData(passData);
      trackDetailView("pass", `${passData.title}`);
    }
  }, []);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handleReserveClick = () => {
    if (selectedPassData?.type === MEMBERSHIP_FOUNDER_TYPE.EXECUTION) {
      navigate(-1);
      sessionStorage.setItem(
        "calendarSelectedTab",
        selectedPassData?.service_type,
      );
      setSelectedTabBar(MENU_ITEM.CALENDAR);
    } else {
      navigate(ROUTE_PATHS.WSM_MEMBERSHIP_PASSES);
    }
  };

  return (
    <div className="wms-mobile-container">
      <div className="calendar_detail-screen-container">
        <div className="calendar_detail-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <span>{highlightLastWord(selectedPassData?.title ?? "")}</span>
        </div>
        <div
          className="calendar-detail-banner-image-container"
          style={{ backgroundImage: `url(${selectedPassData?.pass_image})` }}
        ></div>
        <div className="calendar_detail-date-location-container">
          <div className="detail-container">
            <div className="image">
              <img src={locationIcon} alt="location-logo" />
            </div>
            <div className="right-container">
              <div className="sub-container">
                <span>{selectedPassData?.location}</span>
                <span className="sub-text">
                  {selectedPassData?.sub_location}
                </span>
              </div>
              <button
                onClick={() => handleAppExit(selectedPassData?.location_url)}
              >
                Direction
              </button>
            </div>
          </div>
        </div>
        <div className="calendar_detail-container">
          <span>
            About{" "}
            <span style={{ color: "#ff6b35" }}>{selectedPassData?.title}</span>
          </span>
          <div className="divider"></div>
          <div
            className="sub-title"
            dangerouslySetInnerHTML={{
              __html: selectedPassData?.description || "",
            }}
          ></div>
        </div>
        {selectedPassData?.real_life_images?.length > 0 && (
          <div className="calendar_detail-contact-detail-container">
            <ImageCarousel
              images={selectedPassData?.real_life_images}
              title="In Real"
              subTitle="Life"
            />
          </div>
        )}
        <button
          className="calendar_detail-reserve-btn"
          onClick={handleReserveClick}
        >
          Book UR Slot
        </button>
      </div>
    </div>
  );
};

export default PassDetailScreen;
